import styled from "styled-components";
import Icon from "./Icon";
import * as colors from "../settings/colors";

const IconLink = styled(Icon)`
  fill: #637282;

  &:hover,
  &:active,
  &:focus,
  [aria-expanded="true"] & {
    fill: ${colors.BLUE};
  }
`;

export default IconLink;



// WEBPACK FOOTER //
// ./src/components/IconLink.js